import type { StateStorage } from "zustand/middleware";

// Storybook 에서 dev 앱의 영속 키를 덮어쓰지 않도록 in-memory 로 대체한다.
export const memoryStorage = (): StateStorage => {
  const map = new Map<string, string>();
  return {
    getItem: (k) => map.get(k) ?? null,
    setItem: (k, v) => void map.set(k, v),
    removeItem: (k) => void map.delete(k),
  };
};

// Storybook 의 Vite 빌더가 주입하는 플래그. vite-env.d.ts 수정을 피하려 캐스팅.
export const isStorybook = Boolean(
  (import.meta.env as { STORYBOOK?: unknown }).STORYBOOK,
);
